import validatorjs from 'validatorjs';
import { observable } from "mobx";
import MobxReactForm from 'mobx-react-form';

import hooks from './_.hooks';
import bindings from './_.bindings';
import dvrExtend from './extension/dvr';
// import svkExtend from './extension/svk';

export default class Form extends MobxReactForm {

    @observable display = false;

    bindings() {
        return bindings;
    }

    hooks() {
        return hooks;
    }

    plugins() {
        return {
            dvr: {
                package: validatorjs,
                extend: dvrExtend,
            },
        };
    }

    options() {
        return {
            defaultGenericError: 'Invalid Data',
            autoParseNumbers: true,
        };
    }

    hide() {
        this.display = false;
    }
    show() {
        this.display = true;
    }

    validateField(field, value) {
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/forms/_.extend.js